/**
 * US states + major cities per state, used by the Listing Search form.
 *
 * Cities are biased toward CRE-relevant metros (largest, capitals, well-known
 * office markets) — 5-10 per state, not exhaustive. The user can fall back to
 * a free-text "Other..." choice if a needed city isn't listed.
 */

export const US_STATES = [
    { code: 'AL', name: 'Alabama' },
    { code: 'AK', name: 'Alaska' },
    { code: 'AZ', name: 'Arizona' },
    { code: 'AR', name: 'Arkansas' },
    { code: 'CA', name: 'California' },
    { code: 'CO', name: 'Colorado' },
    { code: 'CT', name: 'Connecticut' },
    { code: 'DE', name: 'Delaware' },
    { code: 'DC', name: 'District of Columbia' },
    { code: 'FL', name: 'Florida' },
    { code: 'GA', name: 'Georgia' },
    { code: 'HI', name: 'Hawaii' },
    { code: 'ID', name: 'Idaho' },
    { code: 'IL', name: 'Illinois' },
    { code: 'IN', name: 'Indiana' },
    { code: 'IA', name: 'Iowa' },
    { code: 'KS', name: 'Kansas' },
    { code: 'KY', name: 'Kentucky' },
    { code: 'LA', name: 'Louisiana' },
    { code: 'ME', name: 'Maine' },
    { code: 'MD', name: 'Maryland' },
    { code: 'MA', name: 'Massachusetts' },
    { code: 'MI', name: 'Michigan' },
    { code: 'MN', name: 'Minnesota' },
    { code: 'MS', name: 'Mississippi' },
    { code: 'MO', name: 'Missouri' },
    { code: 'MT', name: 'Montana' },
    { code: 'NE', name: 'Nebraska' },
    { code: 'NV', name: 'Nevada' },
    { code: 'NH', name: 'New Hampshire' },
    { code: 'NJ', name: 'New Jersey' },
    { code: 'NM', name: 'New Mexico' },
    { code: 'NY', name: 'New York' },
    { code: 'NC', name: 'North Carolina' },
    { code: 'ND', name: 'North Dakota' },
    { code: 'OH', name: 'Ohio' },
    { code: 'OK', name: 'Oklahoma' },
    { code: 'OR', name: 'Oregon' },
    { code: 'PA', name: 'Pennsylvania' },
    { code: 'RI', name: 'Rhode Island' },
    { code: 'SC', name: 'South Carolina' },
    { code: 'SD', name: 'South Dakota' },
    { code: 'TN', name: 'Tennessee' },
    { code: 'TX', name: 'Texas' },
    { code: 'UT', name: 'Utah' },
    { code: 'VT', name: 'Vermont' },
    { code: 'VA', name: 'Virginia' },
    { code: 'WA', name: 'Washington' },
    { code: 'WV', name: 'West Virginia' },
    { code: 'WI', name: 'Wisconsin' },
    { code: 'WY', name: 'Wyoming' },
];

export const MAJOR_CITIES_BY_STATE = {
    AL: ['Birmingham', 'Huntsville', 'Mobile', 'Montgomery', 'Tuscaloosa'],
    AK: ['Anchorage', 'Fairbanks', 'Juneau'],
    AZ: ['Phoenix', 'Tucson', 'Mesa', 'Scottsdale', 'Tempe', 'Chandler', 'Gilbert', 'Glendale'],
    AR: ['Little Rock', 'Fayetteville', 'Bentonville', 'Fort Smith', 'Springdale'],
    CA: ['Los Angeles', 'San Francisco', 'San Diego', 'San Jose', 'Sacramento', 'Oakland', 'Long Beach', 'Anaheim', 'Irvine', 'Santa Monica', 'Pasadena', 'Berkeley', 'Palo Alto', 'Burbank', 'Glendale'],
    CO: ['Denver', 'Colorado Springs', 'Aurora', 'Fort Collins', 'Lakewood', 'Boulder'],
    CT: ['Hartford', 'New Haven', 'Stamford', 'Bridgeport', 'Norwalk', 'Waterbury'],
    DE: ['Wilmington', 'Dover', 'Newark'],
    DC: ['Washington'],
    FL: ['Miami', 'Orlando', 'Tampa', 'Jacksonville', 'Fort Lauderdale', 'St. Petersburg', 'Tallahassee', 'Hialeah', 'Boca Raton', 'West Palm Beach'],
    GA: ['Atlanta', 'Savannah', 'Augusta', 'Columbus', 'Macon', 'Athens', 'Sandy Springs', 'Roswell'],
    HI: ['Honolulu', 'Hilo', 'Kailua'],
    ID: ['Boise', 'Meridian', 'Nampa', 'Idaho Falls'],
    IL: ['Chicago', 'Aurora', 'Naperville', 'Joliet', 'Rockford', 'Springfield', 'Peoria', 'Schaumburg', 'Evanston', 'Oak Brook'],
    IN: ['Indianapolis', 'Fort Wayne', 'Evansville', 'South Bend', 'Carmel', 'Fishers'],
    IA: ['Des Moines', 'Cedar Rapids', 'Davenport', 'Sioux City', 'Iowa City'],
    KS: ['Wichita', 'Overland Park', 'Kansas City', 'Topeka', 'Olathe', 'Lawrence'],
    KY: ['Louisville', 'Lexington', 'Bowling Green', 'Frankfort'],
    LA: ['New Orleans', 'Baton Rouge', 'Shreveport', 'Lafayette', 'Lake Charles'],
    ME: ['Portland', 'Augusta', 'Bangor', 'Lewiston'],
    MD: ['Baltimore', 'Annapolis', 'Frederick', 'Rockville', 'Bethesda', 'Silver Spring', 'Gaithersburg'],
    MA: ['Boston', 'Cambridge', 'Worcester', 'Springfield', 'Lowell', 'Quincy', 'Newton', 'Somerville', 'Waltham'],
    MI: ['Detroit', 'Grand Rapids', 'Ann Arbor', 'Lansing', 'Warren', 'Sterling Heights', 'Troy', 'Dearborn'],
    MN: ['Minneapolis', 'St. Paul', 'Rochester', 'Bloomington', 'Duluth', 'St. Cloud'],
    MS: ['Jackson', 'Gulfport', 'Southaven', 'Biloxi'],
    MO: ['Kansas City', 'St. Louis', 'Springfield', 'Columbia', 'Independence', 'Jefferson City'],
    MT: ['Billings', 'Missoula', 'Bozeman', 'Helena', 'Great Falls'],
    NE: ['Omaha', 'Lincoln', 'Bellevue', 'Grand Island'],
    NV: ['Las Vegas', 'Henderson', 'Reno', 'North Las Vegas', 'Sparks', 'Carson City'],
    NH: ['Manchester', 'Nashua', 'Concord', 'Portsmouth'],
    NJ: ['Newark', 'Jersey City', 'Paterson', 'Elizabeth', 'Edison', 'Trenton', 'Princeton', 'Hoboken'],
    NM: ['Albuquerque', 'Santa Fe', 'Las Cruces', 'Rio Rancho'],
    NY: ['New York', 'Buffalo', 'Rochester', 'Yonkers', 'Syracuse', 'Albany', 'White Plains', 'Long Island City', 'Brooklyn', 'Queens'],
    NC: ['Charlotte', 'Raleigh', 'Greensboro', 'Durham', 'Winston-Salem', 'Cary', 'Asheville', 'Wilmington'],
    ND: ['Fargo', 'Bismarck', 'Grand Forks', 'Minot'],
    OH: ['Columbus', 'Cleveland', 'Cincinnati', 'Toledo', 'Akron', 'Dayton'],
    OK: ['Oklahoma City', 'Tulsa', 'Norman', 'Broken Arrow', 'Edmond'],
    OR: ['Portland', 'Salem', 'Eugene', 'Beaverton', 'Bend', 'Hillsboro'],
    PA: ['Philadelphia', 'Pittsburgh', 'Allentown', 'Erie', 'Reading', 'Harrisburg', 'King of Prussia', 'Lancaster'],
    RI: ['Providence', 'Warwick', 'Cranston', 'Pawtucket'],
    SC: ['Columbia', 'Charleston', 'Greenville', 'Mount Pleasant', 'Rock Hill'],
    SD: ['Sioux Falls', 'Rapid City', 'Pierre'],
    TN: ['Nashville', 'Memphis', 'Knoxville', 'Chattanooga', 'Franklin'],
    TX: ['Houston', 'Dallas', 'Austin', 'San Antonio', 'Fort Worth', 'El Paso', 'Plano', 'Arlington', 'Frisco', 'Irving', 'Lubbock', 'Sugar Land', 'The Woodlands'],
    UT: ['Salt Lake City', 'Provo', 'West Valley City', 'Ogden', 'Sandy', 'Lehi'],
    VT: ['Burlington', 'Montpelier', 'Rutland'],
    VA: ['Richmond', 'Virginia Beach', 'Norfolk', 'Arlington', 'Alexandria', 'Reston', 'Tysons', 'Fairfax'],
    WA: ['Seattle', 'Spokane', 'Tacoma', 'Bellevue', 'Redmond', 'Olympia', 'Vancouver', 'Kirkland'],
    WV: ['Charleston', 'Huntington', 'Morgantown', 'Wheeling'],
    WI: ['Milwaukee', 'Madison', 'Green Bay', 'Kenosha', 'Racine', 'Appleton'],
    WY: ['Cheyenne', 'Casper', 'Laramie', 'Jackson'],
};

export function citiesForState(stateCode) {
    if (!stateCode) return [];
    return MAJOR_CITIES_BY_STATE[stateCode.toUpperCase()] || [];
}
